import { render } from "./PinIcon.vue?vue&type=template&id=2f0d64f4"
const script = {}
script.render = render

export default script